//libs swiperを使う際はbabel管理外にしないといけないので注意
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Main {
    constructor() {
        this.init();
    }

    init() {
        this.swiper();
    }

    swiper() {
        const swipercont = document.querySelector('.discographySwiper');
        const slide = [...swipercont.querySelectorAll('.swiper-slide')];
        if (slide.length === 1) {
            swipercont.classList.add('-slideone');
        }
        
        // discographySwiperのthumbsオプションで使用するため、discography_tracklistSwiperを先に実行する
        const discography_tracklistSwiper = new Swiper('.discography_ContentsSwiper', {
            // slidesPerView: 'auto',
            effect: 'fade',
            allowTouchMove: false,
        });

        const discographySwiper = new Swiper('.discographySwiper', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            navigation: {
                nextEl: '.discographydetailSwiper-next',
                prevEl: '.discographydetailSwiper-prev',
            },
            thumbs: {
                swiper: discography_tracklistSwiper,
            },
            breakpoints: {
                835: {
                    spaceBetween: 24,
                    pagination: {
                        el: '.discographySwiper-pagination',
                        clickable: true,
                    },
                },
            },
        });
    }
}
